// extracted by mini-css-extract-plugin
export var error = "NewsletterForm-module--error--b4f62";
export var form = "NewsletterForm-module--form--1d92d";
export var input = "NewsletterForm-module--input--715cd";
export var inputWrapper = "NewsletterForm-module--input-wrapper--d08db";